import useLocale from '@hooks/useLocale';
import Card from '@molecules/Card/Card';
import Carousel from '@molecules/Carousel/Carousel';
import { OverviewItem } from '@type-declarations/overviewItems';
import getInternalRoute from '@utils/getInternalRoute';

interface Props {
  items: OverviewItem[];
}

export default function NoResults({ items }: Props) {
  const locale = useLocale();

  return (
    <div className="u-container-width">
      <Carousel
        items={items.map(item => ({
          ...item,
          href: getInternalRoute({
            internalLink: item,
            locale,
          }),
          showType: true,
          imageSize: 'md' as const,
        }))}
        SlideItem={Card}
        slidesPerView={{ mobile: 1, tablet: 3.25, desktop: 4 }}
      />
    </div>
  );
}
